import { render, staticRenderFns } from "./KnowledgeDialog.vue?vue&type=template&id=b1d6e716&scoped=true&"
import script from "./KnowledgeDialog.vue?vue&type=script&lang=js&"
export * from "./KnowledgeDialog.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeDialog.vue?vue&type=style&index=0&id=b1d6e716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d6e716",
  null
  
)

export default component.exports